import React, {Component} from 'react'
import {Route, Switch} from 'react-router-dom'
import BannerManager from './BannerManager/BannerManager'
import Portal from './Portal/Portal'
import ArticleList from "../../Component/ArticleList/ArticleList";
import EditArticle from "../../Layout/EditArticle/EditArticle";
import NewArticle from "../../Layout/NewArticle/NewArticle";
import FormRegistration from "../../Layout/FormRegistration/FormRegistration";
import {MDBAlert, MDBContainer} from "mdbreact";
import AdminPostList from "../../Component/AdminPostList/AdminPostList"
import EditPost from "../../Layout/EditPost/EditPost";

import classes from './AdminLayout.module.css'
import PendingRequest from "./PendingRequest/PendingRequest";

class AdminLayout extends Component{
    constructor(props) {
        super(props);
        this.state={

        }
    }

    render() {
        return (
            <div>
               <MDBContainer>
                   <MDBAlert color="warning">
                       Welcome Back! 歡迎! 管理員
                   </MDBAlert>
               </MDBContainer>
                <hr/>
                <Switch>
                    <div className={classes.AdminContainer}>
                        <Route path="/admin/portal" exact
                               component={Portal}/>
                        <Route path="/admin/banner" exact
                               component={BannerManager}/>
                        {/*//TODO AdminOnly(NormalMemberPortalMobileView, this.props.auth)*/}
                        <Route path="/admin/articleList" exact
                               component={ArticleList}/>
                        <Route path="/admin/articleList/editArticle/:id"
                               component={EditArticle}/>
                        <Route path="/admin/admin-postList" exact
                               component={AdminPostList}/>
                        <Route path="/admin/admin-postList/editPost/:id"
                               component={EditPost}/>
                        {/*<Route path="/admin/form-registration"*/}
                        {/*       component={FormRegistration}/>*/}
                        <Route path="/admin/new-article"
                               component={NewArticle}/>
                        <Route path="/admin/pending-request"
                               component={PendingRequest}/>

                    </div>
                </Switch>
            </div>
        );
    }
}
export default AdminLayout